// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { useUniqueId } from '@cloudscape-design/component-toolkit/internal';
import { getBaseProps } from '../../base-component';
import { GroupedControlContext, } from '../../context/control-group-context';
import { flattenChildren } from '../../utils/flatten-children';
import styles from './styles.css.js';
export default function InternalControlGroup({ children, direction = 'horizontal', inlineLabelText, ...props }) {
    const baseProps = getBaseProps(props);
    const labelId = useUniqueId('control-group-label');
    const flattenedChildren = flattenChildren(children, 'ControlGroup');
    const controlCount = flattenedChildren.length;
    const controls = (React.createElement("div", { ...baseProps, role: "group", className: clsx(baseProps.className, styles.root, styles[`root-${direction}`]) }, flattenedChildren.map((child, index) => {
        const key = child && typeof child === 'object' ? child.key : undefined;
        const position = controlCount === 1 ? 'only' : index === 0 ? 'first' : index === controlCount - 1 ? 'last' : 'middle';
        return (React.createElement("div", { key: key ? String(key) : index, className: clsx(styles.control, styles[`control-${position}-${direction}`]) },
            React.createElement(GroupedControlContext.Provider, { value: { position, direction } }, child)));
    })));
    if (inlineLabelText) {
        return (React.createElement("div", { ...baseProps, className: clsx(baseProps.className, styles['inline-label-wrapper']) },
            React.createElement("label", { id: labelId, className: clsx(styles['inline-label']) }, inlineLabelText),
            React.createElement("div", { className: styles['inline-label-trigger-wrapper'] },
                React.createElement("div", { role: "group", "aria-labelledby": labelId, className: styles.root }, controls))));
    }
    return (React.createElement("div", { ...baseProps, role: "group", className: clsx(baseProps.className, styles.root) }, controls));
}
//# sourceMappingURL=index.js.map